module.exports = __webpack_public_path__ + "static/media/bagging.3a82cb88.svg";